import { z } from 'zod';

export const DatabaseScheduleRetryableEnableFor = z.enum([
  'datasets',
  'transforms',
  'post-tlp-flows',
]);

export type DatabaseScheduleRetryableEnableFor = z.infer<
  typeof DatabaseScheduleRetryableEnableFor
>;
